@if (items?.length) {
  @for (item of items; track index; let index = $index; let first = $first; let last = $last) {
    @let isChecked = isItemChecked(index);
    <div class="current-step">
      <span class="current-step--circle" [ngClass]="{ active: item.isActive, checked: isChecked, first: first, last: last }">
        @if (isChecked) {
          <app-icon [name]="IconName.checkmark" class="icon"></app-icon>
        } @else {
          {{ index + 1 }}
        }
      </span>
      <span
        class="current-step--text"
        [ngClass]="{ checked: isChecked }"
        [innerHTML]="(item.mobileLabel && DetectMobile.isMobile() ? item.mobileLabel : item.label) | translateKey | safeHtml"
      ></span>
    </div>
  }
}
